export default "__VITE_ASSET__BE2TJLAg__"